import Api from '@/service/api';
import * as registrationHelper from '@/helpers/registration';
import * as cardActivation from '@/helpers/card-activation';

import Checkbox from '@/components/Form/Checkbox/index.vue';
import Input from '@/components/Form/Input/index.vue';
import CodeVerification from './CodeVerification/index.vue';


export default {
  name: 'EmailVerification',

  components: {
    Checkbox,
    CodeVerification,
    Input,
  },

  mounted() {
    if (this.$route.query.isCardActivation === 'true') {
      this.isCardActivation = true;
      this.getCardData();
    }
  },

  methods: {
    async changeEmail(email) {
      this.email = email;
      const result = await this.validateEmail();

      if (result) {
        this.$refs.codeVerification.setError(result);

        return;
      }

      this.$refs.codeVerification.checkExpirationTime();
    },

    getCardData() {
      const localData = cardActivation.getMoCardData();

      if (localData) {
        this.cardNumber = `000${localData.card_number}`;
        this.cardNumberArray = this.cardNumber.match(/.{1,4}/g);

        if (localData.pin_code) {
          this.pinCode = localData.pin_code;
        }
      } else {
        this.isCardActivation = false;
      }
    },

    async validateEmail(callback = null) {
      if (!this.validate()) {
        return;
      }

      let response = null;

      const data = { email: this.email };

      if (this.isCardActivation) {
        data.card_number = this.cardNumber.replace(/^0+/, '');
        data.pin_code = this.pinCode;
      }

      this.isCanValidateEmail = false;
      try {
        response = await Api.post({
          url: 'validate-email',
          data,
        });
      } catch (error) {
        this.isError = true;
        this.errorCode = error.code;
        this.isCanValidateEmail = true;

        return this.errorCode; // eslint-disable-line
      }

      registrationHelper.clearData();
      registrationHelper.saveExpirationTime({
        email: this.email,
        time: response.data.next_try,
      });

      this.isRegCodeSended = true;
      this.isCanValidateEmail = true;

      if (typeof callback === 'function') {
        callback();
      }
    },

    validate() {
      if (!this.isRegCodeSended) {
        if (!this.$refs.emailField.validate()) {
          this.validated = false;
        }
      }

      if (!this.$refs.termsOfUseAgreementCheckbox.validate()) {
        this.validated = false;
      }

      return this.validated;
    },

    fieldsChanged() {
      this.validated = true;
      this.isError = false;
    },
  },

  created() {
    const localData = registrationHelper.getLast();

    if (localData) {
      this.email = localData.email;
      if (new Date(localData.time) > new Date()) {
        this.isRegCodeSended = true;
      }
    }
  },

  data() {
    return {
      email: '',
      errorCode: null,
      validated: this.validated || true,
      isError: false,
      isRegCodeSended: false,
      isCardActivation: false,
      isCanValidateEmail: true,
      cardNumberArray: [],
      cardNumber: null,
      pinCode: null,
      isChecked: false,
    };
  },
};
